import { render, staticRenderFns } from "./Schedule2.vue?vue&type=template&id=5f4f85b4&"
import script from "./Schedule2.vue?vue&type=script&lang=js&"
export * from "./Schedule2.vue?vue&type=script&lang=js&"
import style0 from "./Schedule2.vue?vue&type=style&index=0&id=5f4f85b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports